/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
}
